import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Button, Divider, Typography } from 'components';
import { useBlockNavigation } from 'providers';

export const ConfirmNavigation: FC = () => {
    const { t } = useTranslation();
    const {
        callback,
        isBlockModalOpen,
        hideBlockModal,
        setIsNavigationBlocked
    } = useBlockNavigation();

    const confirm = () => {
        callback(true);
        setIsNavigationBlocked(false);
        hideBlockModal();
    };

    const cancel = () => {
        callback(false);
        hideBlockModal();
    };

    return (
        <Dialog
            width={500}
            height={250}
            isOpen={isBlockModalOpen}
            onClose={cancel}>
            <Dialog.Header
                title={t('expressions.confirm_navigation_title')}
                onClose={cancel}
            />
            <Dialog.Body>
                <Typography variant="body1">
                    {t('expressions.confirm_navigation_body_1')}
                </Typography>
                <Typography variant="body1" isParagraph>
                    {t('expressions.confirm_navigation_body_2')}
                </Typography>
                <Typography variant="body1">
                    {t('expressions.confirm_navigation_body_3')}
                </Typography>
            </Dialog.Body>
            <Divider orientation="horizontal" spacing={5} />
            <Dialog.Footer>
                <Button type="contained" onClick={confirm}>
                    {t('general.Ok')}
                </Button>
                <Button type="outlined" onClick={cancel}>
                    {t('general.Cancel')}
                </Button>
            </Dialog.Footer>
        </Dialog>
    );
};
